var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _vm._l(_vm.articles, function(articleGroup) {
        return [
          _c(
            "div",
            { staticClass: "row with-gutters--2 mb-3" },
            _vm._l(articleGroup, function(article, index) {
              return _c(
                "div",
                {
                  staticClass: "d-flex align-items-end",
                  class: _vm.columnClasses(articleGroup, index)
                },
                [
                  _c(
                    "div",
                    { staticClass: "w-100 h-auto position-relative" },
                    [
                      _c("img", {
                        staticClass: "w-100 h-auto",
                        attrs: { src: article.thumbnail, alt: "" }
                      }),
                      _vm._v(" "),
                      article.stamp
                        ? _c("stamp", {
                            staticClass:
                              "news-stamp stamp--overlay bg-transparent spot-text"
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row with-gutters--2 mb-5" },
            _vm._l(articleGroup, function(article, index) {
              return _c(
                "div",
                { class: _vm.columnClasses(articleGroup, index) },
                [_c("news-article", { attrs: { article: article } })],
                1
              )
            }),
            0
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }